import React,{useEffect} from "react";
import Pin from "./pin.jpg";
import { TextField, Button } from "@mui/material";
import Swal from "sweetalert2";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";

function Contact() {

  useEffect(()=>{
    window.scrollTo(0,0)
    },[])
    
  
  const submitForm = () => {
    Swal.fire({
      icon: "success",
      title: "Successfully Submitted ",
      text: "Our team will in touch with you with in 2 business days",
      showConfirmButton: true,
    });
  };

  return (
    <div>
         <Header />
      {/* Style */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
                    @media only screen and (max-width: 700px) {
                        h1 {
                          font-size: 31px !important;
                          text-align: center !important;
                          margin: 10px 70px;
                        }
                  
                        #h6 {
                          font-size: 14px !important;
                          text-align: center !important;
                          padding: 2px 23px !important;
                         
                        }
                  
                        span>div {
                          width: 100% !important;
                         
                        }
                   
             
                      sup>img{
                        height: 14px !important;
                          width: 14px !important;
                      }
                     
                  #marginremove{
                  
                      margin-right: 0px;
                      margin-left: 0px;
                  }
                  
                      }
                  
                      
                  
                  
                      #body-contact-us {
                        overflow-x: hidden;
                      }

                      .form-group{
                        margin-bottom: 1.4rem;
                      }

                      @media only screen and (max-width: 425px) {
                      .fg-responsive-button{
                        display:none;
                      }
                      .button-submit-form{
                        display:grid !important;
                        padding: 0px 25px;
                      }
                      }

                      .button-submit-form{
                         display:none;
                      }
                    `,
        }}
      />

      <div>
        {/* Contact Us */}
        <br />
        <br />
        <h1
        data-aos="zoom-in"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
          style={{ textAlign: "center", fontFamily: "Ubuntu" }}
          id="contact-us-id-hash"
        >
          Contact Us
        </h1>
        <br />
        <h6 id="h6" style={{ textAlign: "center", fontWeight: "bold" }}>
          <sup>
            <img id="imgpin " src={Pin} alt="" height="18px" width="18px" />
          </sup>{" "}
          Galveston Island Historic Pleasure Pier, 2501 Seawall Blvd, Galveston,
          TX 77550, United States
        </h6>
        <span>
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              width="100%"
              height="600"
              className="embed-responsive-item"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d222826.34785503836!2d-95.01340200083501!3d29.233504188047117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x863f9e600e04d93d%3A0x61584f6f5b09b36d!2sGalveston%20Island%20Historic%20Pleasure%20Pier!5e0!3m2!1sen!2s!4v1660449779385!5m2!1sen!2s"
            />
          </div>
        </span>
        {/*  */}
        <br />
        <br />
        <br id="usefullink" />
        {/* Form */}
        <h1
          style={{ textAlign: "center", fontFamily: "Ubuntu" }}
          id="forqueries"
        >
          For Queries
        </h1>
        <br />
        <form method="POST" autoComplete="off" style={{ alignItems: "center" }}>
          <div
            className="container-fluid row col-md-12 col-sm-12 align-content-center"
            id="marginremove"
          >
            {/* Extra Dic For  */}
            <div className="container col-md-2 col-sm-12 align-content-center" />
            {/*  */}
            <div className="container col-md-4 col-sm-12 align-content-center">
              <div className="form-group">
                <TextField
                  id="outlined-basic"
                  type="text"
                  // sx={{ mb: 2.8 }}
                  fullWidth
                  label="Full Name"
                  variant="outlined"
                />
              </div>
              <div className="form-group">
                <TextField
                  id="outlined-basic"
                  type="email"
                  // sx={{ mb: 2.8 }}
                  fullWidth
                  label="Email"
                  variant="outlined"
                />
              </div>
              <div className="form-group">
                <TextField
                  id="outlined-basic"
                  type="tel"
                  // sx={{ mb: 2.8 }}
                  fullWidth
                  label="Phone"
                  variant="outlined"
                />
              </div>
              <div className="form-group">
                <TextField
                  id="outlined-basic"
                  type="text"
                  // sx={{ mb: 2.7 }}
                  fullWidth
                  label="Subject"
                  variant="outlined"
                />
              </div>

              <div className="form-group fg-responsive-button">
                <div className="container col-md-2 col-sm-12 align-content-center" />
                <Button
                  variant="contained"
                  sx={{}}
                  size="large"
                  fullWidth
                  className="btn btn-primary"
                  onClick={() => {
                    submitForm();
                  }}
                >
                  Submit
                </Button>
              </div>
            </div>
            <div className="container col-md-4 col-sm-12 align-content-center">
              <div className="form-group">
                <TextField
                  id="outlined-basic"
                  type="text"
                  multiline
                  rows={14}
                  fullWidth
                  label="Message"
                  variant="outlined"
                />
              </div>
            </div>
            {/* Extra Dic For  */}
            <div className="container col-md-2 col-sm-12 align-content-center" />
            {/*  */}
          </div>

          <span>
            <span>
              <div className="button-submit-form">
                <Button variant="contained"
                  sx={{}}
                  size="large" 
                  className="btn btn-primary" 
                  onClick={() => { submitForm()}}>
                  Submit
                </Button>
                {/* <button type="#?" className="btn btn-primary">Submit</button> */}
              </div>
            </span>
          </span>
        </form>
        {/*  */}
        <br />
        <br />
      </div>
      <Footer />

    </div>
  );
}

export default Contact;
